import { useCallback, useEffect } from 'react';
import { useDispatchApp } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { getPersonalDetails } from 'API/personalDetails';
import { setPersonalDetails } from 'Store/PersonalDetailsSlice';

export const usePersonalDetails = () => {
  const dispatch = useDispatchApp();
  const personalDetails = useAppSelector(
    ({ personalDetails: { personalDetails } }) => personalDetails
  );

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const initializePersonalDetails = useCallback(async () => {
    const result = await getPersonalDetails();
    if (result) {
      dispatch(setPersonalDetails(result));
    }
  }, [dispatch]);

  useEffect(() => {
    initializePersonalDetails();
  }, [initializePersonalDetails, imposterId]);

  return personalDetails;
};
